import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { convertStringToBoolean, returnEmpty } from '@core/_utils/tools.utils';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.css'],
})
export class PageContent implements OnInit {
    public isLoading: boolean;
    public pathPdf: string;
    public pathFile: string;
    private docId: string;
    private thumb: string;
    private copyPdf: boolean;
    public loadingMessage = '';
    constructor(private activatedRoute: ActivatedRoute, private api: ApiV6Service,
        private translate: TranslateService) {
        this.loadingMessage = this.translate.instant('Load_Data');
    }

    ngOnInit() {
        this.isLoading = false;
        this.activatedRoute.queryParams.subscribe((params) => {
            this.docId = '';
            this.thumb = '';
            this.copyPdf = true;
            this.docId = params.DocID;
            this.thumb = returnEmpty(params.Thumb);
            if (this.thumb !== '') {
                this.getImage();
            } else {
                this.getParamFile(params);
            }
        });
    }

    private getParamFile(aParams) {
        if (returnEmpty(aParams.copypdf) === '') {
            this.copyPdf = true;
        } else {
            this.copyPdf = this.getDefValue(aParams.copypdf);
        }
        this.getFile();
    }

    private getDefValue(aValue) {
        let wRes = aValue;
        wRes = wRes.trim();
        if (wRes.toLowerCase() === 'true' || wRes.toLowerCase() === 'false') {
            return convertStringToBoolean(wRes);
        } else {
            return true;
        }
    }

    private getFile() {
        if (this.copyPdf === true) {
            this.pathFile = this.api.getPdf(this.docId);
        } else {
            this.pathFile = this.api.getDocument(this.docId);
            this.isLoading = true;
        }
        window.location.assign(this.pathFile);
    }

    private getImage() {
        let wThumb = '160';
        switch (this.thumb) {
            case '320':
            case '640':
            case '800':
                wThumb = this.thumb;
                break;
        }
        this.pathFile = this.api.getThumb(this.docId, wThumb);
        window.location.assign(this.pathFile);
    }
}
